module.exports = __webpack_public_path__ + "img/Speaker=Shafina Hassam.daf0e976.png";